var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #8f003c;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-plus",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_352",
    "data-name": "Trazado 352",
    className: "cls-1",
    d: "M16,21V19a4,4,0,0,0-4-4H5a4,4,0,0,0-4,4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    className: "cls-1",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(4.5 3)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_65",
    "data-name": "L\\xEDnea 65",
    className: "cls-1",
    y2: 6,
    transform: "translate(20 8)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_66",
    "data-name": "L\\xEDnea 66",
    className: "cls-1",
    x1: 6,
    transform: "translate(17 11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.d5627ad2932d32fe29777d35f0aaef64.svg";
export { ForwardRef as ReactComponent };